// extracted by mini-css-extract-plugin
export default {"heading":"Rj-z","createAccount":"Sj-z","disabled":"Tj-z","copy":"Uj-z","terms":"Vj-z"};